export const esPlan = {
  'plan.adjustedOccurrence': 'Ajustada',
  'plan.applyFilters': 'Aplicar filtros',
  'plan.delete': 'Eliminar',
  'plan.deleteOccurrence': 'Omitir esta ocurrencia',
  'plan.deleteSeries': 'Eliminar toda la serie',
  'plan.editOccurrence': 'Editar esta ocurrencia',
  'plan.editSeries': 'Editar la serie',
  'plan.filterDescription': 'Elige el período y qué movimientos quieres ver.',
  'plan.filterTitle': 'Filtrar Plan',
  'plan.limit': 'Limitar',
  'plan.limitClear': 'Sin fecha final',
  'plan.limitDescription': 'La serie se repetirá desde su inicio hasta la fecha final, inclusive.',
  'plan.limitEnd': 'Termina el',
  'plan.limitSave': 'Guardar límite',
  'plan.limitStart': 'Comenzó el',
  'plan.limitTitle': 'Limitar recurrencia',
  'plan.month': 'Mes',
  'plan.movementKind': 'Movimientos',
  'plan.occurrence': 'Ocurrencia',
  'plan.occurrenceDescription':
    'Este cambio afecta sólo esta fecha. La categoría, wallet y tipo permanecen en la serie original.',
  'plan.occurrenceNote': 'Nota para esta fecha',
  'plan.omitOccurrenceWarning': 'Se omitirá solamente el {date}. La serie continuará normalmente.',
  'plan.confirmOmitOccurrence': 'Sí, omitir fecha',
  'plan.options': 'Opciones de movimiento',
  'plan.resetFilters': 'Restablecer',
  'plan.series': 'Serie',
  'plan.showOccurrences': 'Mostrar cada recurrencia',
  'plan.showOccurrencesHelp':
    'Expande una serie mensual o semanal para editar un monto en una fecha específica.',
  'plan.tools': 'Abrir herramientas',
  'plan.year': 'Año',
} as const;

export const enPlan: Record<keyof typeof esPlan, string> = {
  'plan.adjustedOccurrence': 'Adjusted',
  'plan.applyFilters': 'Apply filters',
  'plan.delete': 'Delete',
  'plan.deleteOccurrence': 'Skip this occurrence',
  'plan.deleteSeries': 'Delete entire series',
  'plan.editOccurrence': 'Edit this occurrence',
  'plan.editSeries': 'Edit series',
  'plan.filterDescription': 'Choose the period and the movements you want to see.',
  'plan.filterTitle': 'Filter Plan',
  'plan.limit': 'Limit',
  'plan.limitClear': 'No end date',
  'plan.limitDescription': 'The series will repeat from its start through the end date, inclusive.',
  'plan.limitEnd': 'Ends on',
  'plan.limitSave': 'Save limit',
  'plan.limitStart': 'Started on',
  'plan.limitTitle': 'Limit recurrence',
  'plan.month': 'Month',
  'plan.movementKind': 'Movements',
  'plan.occurrence': 'Occurrence',
  'plan.occurrenceDescription':
    'This change affects only this date. Category, wallet, and type remain on the original series.',
  'plan.occurrenceNote': 'Note for this date',
  'plan.omitOccurrenceWarning': 'Only {date} will be skipped. The series will continue normally.',
  'plan.confirmOmitOccurrence': 'Yes, skip date',
  'plan.options': 'Movement options',
  'plan.resetFilters': 'Reset',
  'plan.series': 'Series',
  'plan.showOccurrences': 'Show every recurrence',
  'plan.showOccurrencesHelp':
    'Expand a monthly or weekly series to edit an amount on a specific date.',
  'plan.tools': 'Open tools',
  'plan.year': 'Year',
};
